import { RESOLUTION_PERMISSIONS } from '@bo-constants/permissions';
import { createSelector } from '@reduxjs/toolkit';
import { selectUserRoles } from '@bo-services/authenticationSlice';

const { RESOLUTION_CREATE } = RESOLUTION_PERMISSIONS;

export const selectHasCreateResolution = createSelector(
  [selectUserRoles],
  (roles) =>
    roles.some((role) =>
      role.permissions.some(
        (permission) => permission.name === RESOLUTION_CREATE
      )
    )
);
